import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Observable} from "rxjs";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import Editor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: 'app-edit-highlight-item',
  templateUrl: './edit-highlight-item.component.html',
  styleUrls: ['./edit-highlight-item.component.scss']
})
export class EditHighlightItemComponent {


  data = inject(MAT_DIALOG_DATA)
  highlighTypeList$!: Observable<any[]>

  constructor(
    private readonly mDatabase: AngularFireDatabase,
    private readonly mDialogRef: MatDialogRef<EditHighlightItemComponent>
  ) {
    this.highlighTypeList$ = mDatabase.list<any>('types/Center Highlight').valueChanges();

  }


  save() {
    if (this.data.highlight && typeof this.data.highlight === 'object') {
      alert(this.data.highlight.highlight);
      this.data.highlight = this.data.highlight.highlight; // Extract the string value
    }
    this.mDialogRef.close(this.data);
  }

    protected readonly Editor = Editor;
}

